export const firmaDigitalRoutesMap = {
  gestion: {
    path: '/firmaDigital/gestion',
    name: 'Firma Digital',
  },
}
